import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpfCnpjMaskPipe } from './cpf-cnpj-mask.pipe';
import { MaskPipe } from 'ngx-mask';

@NgModule({
  declarations: [CpfCnpjMaskPipe],
  imports: [CommonModule],
  exports: [CpfCnpjMaskPipe],
  providers: [MaskPipe, CpfCnpjMaskPipe]
})
export class CpfCnpjMaskModule { }